import React from "react";

type Tone = "dark" | "light";

type Props = React.HTMLAttributes<HTMLDivElement> & {
  tone?: Tone;
  padded?: boolean;
};

export default function Card({
  tone = "dark",
  padded = true,
  className = "",
  children,
  ...rest
}: Props) {
  const base =
    tone === "dark"
      ? "bg-gradient-to-b from-surface to-surface/75 text-white border-primary/40 shadow-depth"
      : "bg-white text-ink border-black/5 shadow-card";
  return (
    <div
      {...rest}
      className={[
        "rounded-card border",
        padded ? "p-5" : "",
        base,
        className,
      ].join(" ")}
    >
      {children}
    </div>
  );
}
